<section class="budget" aria-labelledby="budget-title">
  <div class="budget__bg" aria-hidden="true"></div>
  <div class="budget__inner">
    <article class="budget__card">
      <h2 id="budget-title" class="budget__title">
        Seu evento também pode continuar gerando impacto depois do último dia.
      </h2>
      <p class="budget__text">
        Coberturas pensadas para redes sociais, conteúdo em tempo real e registros que fortalecem
        a experiência do público e a divulgação do evento.
      </p>
      <app-pill-button
        label="Fazer orçamento"
        variant="gold"
        [href]="whatsappUrl"
        [external]="true"
      />
    </article>
  </div>
</section>
